import { render, staticRenderFns } from "./wxRevisekucun.vue?vue&type=template&id=4b97bd17&scoped=true"
import script from "./wxRevisekucun.vue?vue&type=script&lang=js"
export * from "./wxRevisekucun.vue?vue&type=script&lang=js"
import style0 from "./wxRevisekucun.vue?vue&type=style&index=0&id=4b97bd17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b97bd17",
  null
  
)

export default component.exports